module.exports = __webpack_public_path__ + "img/shichituan.c33b0d0d.png";